const config = {
    apiKey: "AIzaSyDKr8r7o0vivu85fyRhn7bIn6j5GxljX8w",
    authDomain: "oatutor-askoski.firebaseapp.com",
    databaseURL: "https://oatutor-askoski.firebaseio.com",
    projectId: "oatutor-askoski",
    storageBucket: "oatutor-askoski.appspot.com",
    messagingSenderId: "1050614582892",
    appId: "1:1050614582892:web:f7ffec360148dc17da1249",
    measurementId: "G-44V1SE1GEF"
}; 

export default config;

